<template>
  <div class="authlist-import-repeat-view">
    <div class="desc-box">
      <span>
        导入{{ resultData.totalCount || 0 }}条设备信息，
        <span class="error-color">{{ (resultData.repeatCount || 0) + (resultData.exceptionCount || 0) }}条</span>导入失败，其中存在
        <span class="error-color">{{ resultData.repeatCount }}条</span>重复的设备！
        <span class="error-color">{{ resultData.exceptionCount || 0 }}条</span>导入异常的设备，
        编码如下：
      </span>
    </div>
    <r-table
      class="repeatdata-table"
      stripe
      :ref="tableVarity"
      :columns="tableColumn"
      :dataSource="tableData"
      :options="options"
    ></r-table>
    <div style="text-align: center; padding: 20px">
      <el-button class="submit-btn" @click="handleConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'

export default {
  props: {
    resultData: {
      type: Object,
      default: () => ({})
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  mixins: [ tableMix ],
  components: { RTable },
  data() {
    return {
      tableData: [],
      tableVarity: 'repeatdata-table',
      tableColumn: [],
      options: {
        multiSelect: false, // 多选
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: false,
        selection: false,
        stripe: true
      },
    }
  },
  created() {
    this.initTableColumns()
    this.initTableData()
  },
  watch: {
    resultData() {
      this.initTableData()
    }
  },
  methods: {
    initTableData() {
      let repArr = this.resultData.data.repeatCodeList || []
      let errArr = this.resultData.data.exceptionCodeList || []
      let repLen = repArr.length
      let errLen = errArr.length
      let maxLen = errLen > repLen ? errLen : repLen

      let arr = []
      for (let i = 0; i < maxLen; i++) {
        arr.push({ repeatCode: repArr[i] || '', errorCode: errArr[i] || '' })
      }

      this.tableData = arr
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'repeatCode', label: '重复设备编码', visible: true, minWidth: 200 },
        { prop: 'errorCode', label: '异常设备编码', visible: true, minWidth: 200 },
      ]

      this.tableColumn = columns
    },
    // 处理关闭确定
    handleConfirm() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.desc-box {
  display: flex;
  flex-direction: column;
  color: #303133;
  font-weight: 600;
  span {
    margin-bottom: 5px;
  }
}
.error-color {
  color: #F56C6C;
}
.repeatdata-table {
  margin-top: 10px;
  width: 100%;
  max-height: 60vh;
  /deep/ .el-table {
    max-height: calc(~'60vh - 46px') !important;
  }
  /deep/ .el-table__body-wrapper {
    max-height: calc(~'60vh - 46px') !important;
  }
  /deep/ .table-border-wrapper {
    padding: 0px !important;
  }
}
</style>